import React from "react";

const DonationPage = () => {
  const donationLinks = {
    5: "https://www.paypal.com/ncp/payment/CN4UZQZ2QCQA6",
    10: "https://www.paypal.com/ncp/payment/MYEQT4D3DA4LE",
    20: "https://www.paypal.com/ncp/payment/3H4MNRUNDH4AL",
    50: "https://www.paypal.com/ncp/payment/V9A76BTYF5QXA",
    100: "https://www.paypal.com/ncp/payment/JPJ5AH49PNNZC",
  };

  const customAmountLink = "https://www.paypal.com/ncp/payment/TVXJEW8PT2RXL";

  return (
    <section className="mt-20 min-h-screen bg-gray-100 text-sky-950 p-8">
      <div className="mt-20 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
        {/* Header */}
        <h1 className="text-4xl font-bold text-center mb-6">
          Make a Difference Today
        </h1>
        <p className="text-center text-lg mb-8">
          Your generous contribution helps us support underprivileged communities in need.
        </p>

        {/* Preset Amount Buttons */}
        <div className="flex flex-wrap justify-center gap-6 mb-10">
          {Object.entries(donationLinks).map(([amount, url]) => (
            <a
              key={amount}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block py-4 px-10 rounded-full bg-sky-950 text-white text-lg font-semibold hover:bg-gray-500 transition-all duration-300 shadow-md"
            >
              ${amount}
            </a>
          ))}
        </div>

        {/* Custom Amount Button */}
        <div className="text-center mb-10">
          <p className="text-lg font-medium mb-4">Or choose your own amount:</p>
          <a
            href={customAmountLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block py-4 px-10 rounded-full bg-gray-300 text-sky-950 text-lg font-semibold hover:bg-gray-400 transition-all duration-300 shadow-md"
          >
            Custom Amount
          </a>
        </div>

        {/* Zelle Info */}
        <p className="zelle text-center text-lg font-medium mt-10 mb-24">
          Prefer Zelle - Send your donation to:{" "}
          <span
            className="text-sky-600 underline"
          >
            nisaandsabirfoundation@gmail.com
          </span>
        </p>

        {/* Security Disclaimer */}
        <p className="text-sm text-gray-500 text-center mt-6">
          All donations (except Zelle) are processed through PayPal. Please see their{" "}
          <a
            href="https://www.paypal.com/us/legalhub/paypal/privacy-full"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sky-600 underline hover:text-sky-800"
          >
            privacy policy
          </a>{" "}
          here.
        </p>
      </div>
    </section>
  );
};

export default DonationPage;
